import { useEffect, useState } from "react";
import { getUserData } from "../../services/auth";
import MintOriginModal from "../../components/modal/MintOriginModal";
import { clientNetwork, devPrincipal } from "../../lib/constants";
import UpdateOriginModal from "../../components/modal/UpdateOriginModal";
import { getInterfaceInfo } from "../../services/chime";

const appOrigin = window.location.origin;
const ActivateInterface = () => {
    const [showActivateBtn, setShowActivateBtn] = useState(false);
    const [showUpdateBtn, setShowUpdateBtn] = useState(false);

    const [mintOriginModal, setMintOriginModal] = useState(false);
    const [updateOriginModal, setUpdateOriginModal] = useState(false);
    function openMintOriginModal() { setMintOriginModal(true); }
    function openUpdateOriginModal() { setUpdateOriginModal(true); }

    const authUser = getUserData().profile.stxAddress.testnet;
    //const authUser = getUserData().profile.stxAddress.testnet;
    
    async function init() {
        if (devPrincipal === authUser || 'SP8QXHTJAZBXKQV7ZYK5YBQ6D29DQ50HMAV97C2S' === authUser) {
            try {
                const { devPrincipal: devAddress } = await getInterfaceInfo();
                if (devAddress === authUser || 'SP8QXHTJAZBXKQV7ZYK5YBQ6D29DQ50HMAV97C2S' === authUser) {
                    setShowActivateBtn(false);
                    setShowUpdateBtn(true);
                }
            } catch (error) {
                setShowActivateBtn(true);
                setShowUpdateBtn(false);
            }
            return
        }
        setShowActivateBtn(false);
        setShowUpdateBtn(false);
    }

    useEffect(() => {
        init();
    }, [])

    useEffect(() => {
    }, [showActivateBtn, showUpdateBtn])

    return (
        <>
            {/* {showActivateBtn &&  */}
            <button className={'settings-button'} onClick={openMintOriginModal}
            // disabled={!showActivateBtn}
            >Activate Origin</button>
            {/* } */}
            {showUpdateBtn && <button className={'settings-button'} onClick={openUpdateOriginModal} disabled={!showUpdateBtn}>Update Origin</button>}
            {mintOriginModal && <MintOriginModal show={mintOriginModal} close={() => setMintOriginModal(false)} />}
            {updateOriginModal && <UpdateOriginModal show={updateOriginModal} close={() => setUpdateOriginModal(false)} />}
        </>

    );
}

export default ActivateInterface;